import { maskDecimal } from '@givebutter/util';
import { Percentage, Wrapper } from './styled';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { transformCurrencyToCompactNumberFormat } from 'helpers/formatting';
import { Campaign } from 'types/domain';

interface RaisedProps {
    item: Campaign;
}

const Raised = ({ item }: RaisedProps) => {
    const { raised, goal, raised_percentage } = item;
    const currencySymbol = useCurrencySymbol();
    const raisedPercent = Math.min(raised_percentage ?? 0, 100);
    return (
        <Wrapper>
            <p>
                {currencySymbol}
                {maskDecimal(raised)}
            </p>
            {goal && raisedPercent ? (
                <>
                    <Percentage percent={raisedPercent} />
                    <p>
                        {currencySymbol}
                        {transformCurrencyToCompactNumberFormat(goal)}
                    </p>
                </>
            ) : null}
        </Wrapper>
    );
};

export default Raised;
